import { Card } from "./Card";
import { getElementOrLogError } from '../../utils/utils';
export class CardDetails extends Card {
    constructor(template, events, actions) {
        super(template, actions);
        this.events = events;
        this.descriptionElement = getElementOrLogError('.card__text', this._cardElement);
        this.actionButton = getElementOrLogError('.card__button', this._cardElement);
        this.initializeEventListeners();
    }
    initializeEventListeners() {
        this.actionButton.addEventListener('click', () => this.events.emit('product:addToBasket'));
    }
    getActionButtonText(product) {
        if (product.price) {
            return 'Купить';
        }
        else {
            this.actionButton.setAttribute('disabled', 'true');
            return 'Не продается';
        }
    }
    render(product) {
        this.updateCardElements(product);
        this.setTextContent(this.descriptionElement, product.description);
        this.actionButton.textContent = this.getActionButtonText(product);
        return this._cardElement;
    }
}
